import getFeatureService from './get-feature-service.js';
import configStore from '../config-store/index.js';

export default getFeatureService(configStore);
